module.exports = __webpack_public_path__ + "stop_icon.svg?1796309589f382b2b7c4cb266871b4da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stop_icon.svg
// module id = 36
// module chunks = 0